// site/src/components/molecules/card/index.js
export { default } from './Card.tsx';
